module.exports = __webpack_public_path__ + "img/loading.c9f5e67a.png";